import React, { useState } from "react";
import {
  Row,
  Column,
  FormGroup,
  TextArea,
  RadioButtonGroup,
  RadioButton,
  TextInput,
} from "carbon-components-react";

const EnvironmentalSocialAnalysisForm = ({
  businessPlan,
  disabled,
  register,
  errors,
}) => {
  return (
    <FormGroup
      legendText="8	ANÁLISE AMBIENTAL E SOCIAL "
      className="section-header"
    >
      <fieldset className="bx--fieldset required" style={{ marginBottom: "0" }}>
        <legend className="bx--label">
          8.1. A actividade que pretende desenvolver, enquadra-se na categoria
          ambiental C? Se sim, explique de forma breve.
        </legend>
        <Row>
          <Column sm={12} md={12} lg={12}>
            <div className="bx--form__helper-text">
              [Marque com um X a sua resposta. E apresenta a explicação em caso
              afirmativo. Use no máximo 100 palavras. ]
            </div>
          </Column>
          <Column>
            <RadioButtonGroup
              name="isCategoryCActivity"
              disabled={disabled}
              valueSelected={businessPlan?.isCategoryCActivity}
            >
              <RadioButton
                labelText="Sim"
                value={true}
                id="isCategoryCActivity-y"
                {...register("isCategoryCActivity")}
              />
              <RadioButton
                labelText="Não"
                value={false}
                id="isCategoryCActivity-n"
                {...register("isCategoryCActivity")}
              />
            </RadioButtonGroup>
            <p className="field-error">{errors.isCategoryCActivity?.message}</p>
          </Column>
        </Row>
        <Row>
          <Column xsm={12} sm={12} md={12} lg={12}>
            <TextArea
              id="categoryCActivityDesc"
              labelText=""
              rows={7}
              enableCounter
              disabled={disabled}
              {...register("categoryCActivityDesc")}
            />
            <p className="field-error">
              {errors.categoryCActivityDesc?.message}
            </p>
          </Column>
        </Row>
      </fieldset>
      <fieldset className="bx--fieldset required" style={{ marginBottom: "0" }}>
        <legend className="bx--label">
          8.2 Possui um local já identificado para implementar o seu plano de
          negócio? Se sim, descreva as condições físico-naturais do local onde
          vai implementar o seu plano de negócio.
        </legend>
        <Row>
          <Column sm={12} md={12} lg={12}>
            <div className="bx--form__helper-text">
              [Entenda-se por condições físico-naturais, os tipos de relevo,
              solo, clima, vegetação, hidrologia e fauna. Use no máximo 200
              palavras.]
            </div>
          </Column>
          <Column>
            <RadioButtonGroup
              name="hasImplementationLocation"
              disabled={disabled}
              valueSelected={businessPlan?.hasImplementationLocation}
            >
              <RadioButton
                labelText="Sim"
                value={true}
                id="hasImplementationLocation-y"
                {...register("hasImplementationLocation")}
              />
              <RadioButton
                labelText="Não"
                value={false}
                id="hasImplementationLocation-n"
                {...register("hasImplementationLocation")}
              />
            </RadioButtonGroup>
            <p className="field-error">
              {errors.hasImplementationLocation?.message}
            </p>
          </Column>
        </Row>
        <Row>
          <Column xsm={12} sm={12} md={12} lg={12}>
            <TextArea
              id="locationPhysicalNaturalConditions"
              labelText=""
              rows={7}
              enableCounter
              disabled={disabled}
              {...register("locationPhysicalNaturalConditions")}
            />
            <p className="field-error">
              {errors.locationPhysicalNaturalConditions?.message}
            </p>
          </Column>
        </Row>
      </fieldset>
      <fieldset fieldset className="bx--fieldset">
        <Row>
          <Column xsm={12} sm={12} md={12} lg={12} className="required">
            <TextArea
              id="risksNegativeEnvironmentalSocialImpacts"
              labelText="8.3 Com base no tipo de produtos e/ou serviços que pretende fornecer, identifique os possíveis riscos e impactos ambientais negativos e sociais causados pelo seu negócio."
              rows={7}
              enableCounter
              disabled={disabled}
              helperText="[Indique os possíveis riscos e impactos ambientais negativos causados pelo negócio bem como as medidas que colocará em prática para minimizar tais riscos e impactos. A sua descrição deve ser consistente com o tipo de actividade indicado na Secção 3. Use no máximo 200 palavras.]"
              {...register("risksNegativeEnvironmentalSocialImpacts")}
            />
            <p className="field-error">
              {errors.risksNegativeEnvironmentalSocialImpacts?.message}
            </p>
          </Column>
        </Row>
      </fieldset>
      <fieldset fieldset className="bx--fieldset">
        <Row>
          <Column xsm={12} sm={12} md={12} lg={12} className="required">
            <TextArea
              id="mitigationMeasures"
              labelText="8.4 Apresente a proposta inicial das medidas de mitigação para os possíveis riscos e impactos identificados."
              rows={7}
              enableCounter
              disabled={disabled}
              helperText="[Indique as medidas que colocará em prática para minimizar tais riscos e impactos. Use no máximo 200 palavras.]"
              {...register("mitigationMeasures")}
            />
            <p className="field-error">{errors.mitigationMeasures?.message}</p>
          </Column>
        </Row>
      </fieldset>
      <fieldset className="bx--fieldset required" style={{ marginBottom: "0" }}>
        <legend className="bx--label">
          8.5 O seu plano de negócios envolve o uso de terra?
        </legend>
        <Row>
          <Column>
            <RadioButtonGroup
              name="doesInvolveTheUseOfLand"
              disabled={disabled}
              valueSelected={businessPlan?.doesInvolveTheUseOfLand}
            >
              <RadioButton
                labelText="Sim"
                value={true}
                id="doesInvolveTheUseOfLand-y"
                {...register("doesInvolveTheUseOfLand")}
              />
              <RadioButton
                labelText="Não"
                value={false}
                id="doesInvolveTheUseOfLand-n"
                {...register("doesInvolveTheUseOfLand")}
              />
            </RadioButtonGroup>
            <p className="field-error">
              {errors.doesInvolveTheUseOfLand?.message}
            </p>
          </Column>
        </Row>
      </fieldset>
      <fieldset className="bx--fieldset required" style={{ marginBottom: "0" }}>
        <legend className="bx--label">
          8.5.1 Se sim, possui algum título formal de posse de terra?
        </legend>
        <Row>
          <Column>
            <RadioButtonGroup
              name="hasSomeFormalLandTitle"
              disabled={disabled}
              valueSelected={businessPlan?.hasSomeFormalLandTitle}
            >
              <RadioButton
                labelText="Sim"
                value={true}
                id="hasSomeFormalLandTitle-y"
                {...register("hasSomeFormalLandTitle")}
              />
              <RadioButton
                labelText="Não"
                value={false}
                id="hasSomeFormalLandTitle-n"
                {...register("hasSomeFormalLandTitle")}
              />
            </RadioButtonGroup>
            <p className="field-error">
              {errors.hasSomeFormalLandTitle?.message}
            </p>
          </Column>
        </Row>
      </fieldset>

      <fieldset fieldset className="bx--fieldset">
        <Row>
          <Column xsm={12} sm={12} md={6} lg={6}>
            <TextInput
              id="formalLandTitle"
              labelText="8.5.2 Caso possua algum título formal de posse de terra, especifique abaixo."
              disabled={disabled}
              maxLength={100}
              {...register("formalLandTitle")}
            />
            <p className="field-error">{errors.formalLandTitle?.message}</p>
          </Column>
        </Row>
      </fieldset>
      <fieldset className="bx--fieldset required" style={{ marginBottom: "0" }}>
        <legend className="bx--label">8.5.3 O seu título é válido?</legend>
        <Row>
          <Column>
            <RadioButtonGroup
              name="isTitleValid"
              disabled={disabled}
              valueSelected={businessPlan?.isTitleValid}
            >
              <RadioButton
                labelText="Sim"
                value={true}
                id="isTitleValid-y"
                {...register("isTitleValid")}
              />
              <RadioButton
                labelText="Não"
                value={false}
                id="isTitleValid-n"
                {...register("isTitleValid")}
              />
            </RadioButtonGroup>
            <p className="field-error">{errors.isTitleValid?.message}</p>
          </Column>
        </Row>
      </fieldset>
      <fieldset className="bx--fieldset required" style={{ marginBottom: "0" }}>
        <legend className="bx--label">
          8.6 O seu plano de negócios envolve reabilitações/construções?{" "}
        </legend>
        <Row>
          <Column>
            <RadioButtonGroup
              name="doesInvolveRehabilitationOronstruction"
              disabled={disabled}
              valueSelected={
                businessPlan?.doesInvolveRehabilitationOronstruction
              }
            >
              <RadioButton
                labelText="Sim"
                value={true}
                id="doesInvolveRehabilitationOronstruction-y"
                {...register("doesInvolveRehabilitationOronstruction")}
              />
              <RadioButton
                labelText="Não"
                value={false}
                id="doesInvolveRehabilitationOronstruction-n"
                {...register("doesInvolveRehabilitationOronstruction")}
              />
            </RadioButtonGroup>
            <p className="field-error">
              {errors.doesInvolveRehabilitationOronstruction?.message}
            </p>
          </Column>
        </Row>
      </fieldset>
      <fieldset className="bx--fieldset required" style={{ marginBottom: "0" }}>
        <legend className="bx--label">
          8.6.1 Se sim, possui uma licença válida para o efeito?
        </legend>
        <Row>
          <Column>
            <RadioButtonGroup
              name="hasValidLicence"
              disabled={disabled}
              valueSelected={businessPlan?.hasValidLicence}
            >
              <RadioButton
                labelText="Sim"
                value={true}
                id="hasValidLicence-y"
                {...register("hasValidLicence")}
              />
              <RadioButton
                labelText="Não"
                value={false}
                id="hasValidLicence-n"
                {...register("hasValidLicence")}
              />
            </RadioButtonGroup>
            <p className="field-error">{errors.hasValidLicence?.message}</p>
          </Column>
        </Row>
      </fieldset>
    </FormGroup>
  );
};

EnvironmentalSocialAnalysisForm.defaultProps = {
  disabled: false,
};
export default EnvironmentalSocialAnalysisForm;
